import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            fromDate: null,
            toDate: null,
            filter: '',
            subscriptions: [],
            states: [
                {
                    id: 'ACTIVE',
                    label: 'ACTIVE'
                },
                {
                    id: 'CANCELED',
                    label: 'CANCELED'
                },
                {
                    id: 'EXTENDED',
                    label: 'EXTENDED'
                },
                {
                    id: 'FAILURE',
                    label: 'FAILURE'
                },
            ],
            selectedState: {
                id: 'ACTIVE',
                label: 'ACTIVE'
            },
            allCustomCategories: [],
            selectedCustomCategories: [],
            showTotalPrice: CONFIG_COMPANY.SHOW_TOTAL_PRICE_REPORT,
            showPaymentColumn: CONFIG_COMPANY.SHOW_PAYMENT_MONEY_IN_PAYMENT_REPORT,
            totalPrice: 0,
            totalDebt: 0,
            totalCount: 0,
            isMainAdmin: false
        }
    },
    computed: {

        filteredSubscription() {
            let _self = this;
            var userCustomLocation = this.selectedCustomCategories.length > 0 ? this.selectedCustomCategories[0] : '';
            let cPayments = userCustomLocation !== '' ? this.subscriptions.filter(e => e.userCustomLocation === userCustomLocation) : this.subscriptions;
            return cPayments.filter(item => {
                return item.firstName.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                item.lastName.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                item.username.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1;
            })
        }
    },
    methods: {
        load: load,
        clickSearch: clickSearch,
        checkNull: checkNull,
        displaySaradnik: displaySaradnik,
        clickSelectCustomCategory: clickSelectCustomCategory,
        keymonitor: keymonitor,
        isSelected: isSelected,
        displayAdditionalKit: displayAdditionalKit,
        getChipClass: getChipClass,
        paymentUser: paymentUser,
        formatDate: formatDate,
        formatDateAndTime: formatDateAndTime,
        getChipClassState: getChipClassState,
        isSelectedState: isSelectedState,
        onClickState: onClickState,

    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_USER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.isMainAdmin = session.isMainAdmin();
        this.role = session.getRole();
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.load()
        this.allCustomCategories = session.getConfig().customCategories.split(";");
    },
    watch: {
        'filter': function (newVal) {

        }
    }
}

function clickSearch() {
    this.load()
}

function load() {
    let _self = this

    AdminApiService.getSubscriptions(this.selectedState.id)
        .then((response) => {
            _self.subscriptions = response.data
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })


}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function formatDateAndTime(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY HH:mm')
}

function displaySaradnik(item) {
    if (item.isForCompany && (item.companyPayment != null && item.companyPayment !== '')) {
        return item.companyPayment;
    } else {
        return '/';
    }
}

function displayAdditionalKit(kit) {
    if (kit != null && kit.length > 0) {
        return kit;
    } else {
        return '/';
    }
}

function checkNull(data) {
    if (data == null) return '';
    return data;
}

function getChipClass(item) {
    if (this.selectedCustomCategories.includes(item)) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelected(item) {
    return this.selectedCustomCategories.includes(item)
}

function clickSelectCustomCategory(item) {
    if (this.selectedCustomCategories.includes(item)) {
        this.selectedCustomCategories = [];
    } else {
        this.selectedCustomCategories = [];
        this.selectedCustomCategories.push(item)
    }
}

function getChipClassState(item){
    if(this.selectedState.id === item.id){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelectedState(item){
    return this.selectedState.id === item.id
}

function onClickState(item){
    if(this.selectedState.id === item.id){
        this.selectedState = {
            id: 'ACTIVE',
            label: 'ACTIVE'
        };
    }else{
        this.selectedState = item;
    }
    this.load();
}


function paymentUser(payment) {
    this.$router.push('/user-profile?id=' +  payment.userId + '&name=' + payment.name + ' ' + payment.surname + '&type=payments')
}


// WEBPACK FOOTER //
// ./src/components/SubscriptionReport/SubscriptionReport.js